     
// App.js
import { Routes, Route } from 'react-router-dom';
import Home from "./pages/home/Home";
import Hotel from "./pages/hotel/Hotels";
import List from "./pages/list/List";

import Login from './pages/loginRegistration/Login';
import Registration from './pages/loginRegistration/Registration';
const App = () => {
 return (
    <>
       <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hotels" element={<List/>}/>
        <Route path="/hotels/:id" element={<Hotel/>}/>
        <Route path="/Login" element={<Login/>}/>
        <Route path="/Registration" element={<Registration/>}/>
       </Routes>
    </>
 );
};

export default App;
